export const mapClickActions = {
    SetCurrentLocation: 'setCurrentLocation',
    SetWayfindingLocation: 'setWayfindingLocation',
    None: 'none'
};
